import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=2887f01e&"
import script from "./Progress.vue?vue&type=script&lang=js&"
export * from "./Progress.vue?vue&type=script&lang=js&"
import style0 from "./Progress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports